import '../../styles/Title.css'
export default function Title({text}) {

    return(
        <div className="text-container">
            <h1 className="title-text">{text}</h1>
        </div>
    )

}